<template>
  <div class="bbp-create-invoice" @click="goToClientCard">
    <i class="bbp-icon-edit bbp-toolbar-icon bbp-create-invoice__icon"/>
    <span class="bbp-create-invoice__text">Create Invoice</span>
  </div>
</template>

<script>
import {get} from 'lodash'

export default {
  name: 'BBPCreateInvoice',
  props: ['row'],
  methods: {
    goToClientCard () {
      const clientId = get(this.row, 'client.id', '')
      if (!clientId) return
      this.$router.push({
        name: 'ContactCard',
        params: {id: clientId}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-create-invoice {
    @include global-font;
    display: inline-grid;
    grid-template-columns: 22px auto;
    align-items: center;
    justify-content: center;
    color: $color-accent;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      color: $color-accent-hover;
    }

    &:hover &__icon {
      &:after {
        opacity: 0.8;
      }
    }

    &__icon {
      font-size: 25px;
      color: $color-white;
    }

    &__text {
      position: relative;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      z-index: 3;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPCreateInvoice/BBPCreateInvoice.vue